export const states = [
  {
      "long": "Alabama",
      "short": "AL"
  },
  {
      "long": "Alaska",
      "short": "AK"
  },
  {
      "long": "American Samoa",
      "short": "AS"
  },
  {
      "long": "Arizona",
      "short": "AZ"
  },
  {
      "long": "Arkansas",
      "short": "AR"
  },
  {
      "long": "California",
      "short": "CA"
  },
  {
      "long": "Colorado",
      "short": "CO"
  },
  {
      "long": "Connecticut",
      "short": "CT"
  },
  {
      "long": "Delaware",
      "short": "DE"
  },
  {
      "long": "District Of Columbia",
      "short": "DC"
  },
  {
      "long": "Federated States Of Micronesia",
      "short": "FM"
  },
  {
      "long": "Florida",
      "short": "FL"
  },
  {
      "long": "Georgia",
      "short": "GA"
  },
  {
      "long": "Guam",
      "short": "GU"
  },
  {
      "long": "Hawaii",
      "short": "HI"
  },
  {
      "long": "Idaho",
      "short": "ID"
  },
  {
      "long": "Illinois",
      "short": "IL"
  },
  {
      "long": "Indiana",
      "short": "IN"
  },
  {
      "long": "Iowa",
      "short": "IA"
  },
  {
      "long": "Kansas",
      "short": "KS"
  },
  {
      "long": "Kentucky",
      "short": "KY"
  },
  {
      "long": "Louisiana",
      "short": "LA"
  },
  {
      "long": "Maine",
      "short": "ME"
  },
  {
      "long": "Marshall Islands",
      "short": "MH"
  },
  {
      "long": "Maryland",
      "short": "MD"
  },
  {
      "long": "Massachusetts",
      "short": "MA"
  },
  {
      "long": "Michigan",
      "short": "MI"
  },
  {
      "long": "Minnesota",
      "short": "MN"
  },
  {
      "long": "Mississippi",
      "short": "MS"
  },
  {
      "long": "Missouri",
      "short": "MO"
  },
  {
      "long": "Montana",
      "short": "MT"
  },
  {
      "long": "Nebraska",
      "short": "NE"
  },
  {
      "long": "Nevada",
      "short": "NV"
  },
  {
      "long": "New Hampshire",
      "short": "NH"
  },
  {
      "long": "New Jersey",
      "short": "NJ"
  },
  {
      "long": "New Mexico",
      "short": "NM"
  },
  {
      "long": "New York",
      "short": "NY"
  },
  {
      "long": "North Carolina",
      "short": "NC"
  },
  {
      "long": "North Dakota",
      "short": "ND"
  },
  {
      "long": "Northern Mariana Islands",
      "short": "MP"
  },
  {
      "long": "Ohio",
      "short": "OH"
  },
  {
      "long": "Oklahoma",
      "short": "OK"
  },
  {
      "long": "Oregon",
      "short": "OR"
  },
  {
      "long": "Palau",
      "short": "PW"
  },
  {
      "long": "Pennsylvania",
      "short": "PA"
  },
  {
      "long": "Puerto Rico",
      "short": "PR"
  },
  {
      "long": "Rhode Island",
      "short": "RI"
  },
  {
      "long": "South Carolina",
      "short": "SC"
  },
  {
      "long": "South Dakota",
      "short": "SD"
  },
  {
      "long": "Tennessee",
      "short": "TN"
  },
  {
      "long": "Texas",
      "short": "TX"
  },
  {
      "long": "Utah",
      "short": "UT"
  },
  {
      "long": "Vermont",
      "short": "VT"
  },
  {
      "long": "Virgin Islands",
      "short": "VI"
  },
  {
      "long": "Virginia",
      "short": "VA"
  },
  {
      "long": "Washington",
      "short": "WA"
  },
  {
      "long": "West Virginia",
      "short": "WV"
  },
  {
      "long": "Wisconsin",
      "short": "WI"
  },
  {
      "long": "Wyoming",
      "short": "WY"
  }
];

export const provinces = [
{
    "long": "Alberta",
    "short": "AB"
},
{
    "long": "British Columbia",
    "short": "BC"
},
{
    "long": "Manitoba",
    "short": "MB"
},
{
    "long": "New Brunswick",
    "short": "NB"
},
{
    "long": "Newfoundland and Labrador",
    "short": "NL"
},
{
    "long": "Nova Scotia",
    "short": "NS"
},
{
    "long": "Northwest Territories",
    "short": "NT"
},
{
    "long": "Nunavut",
    "short": "NU"
},
{
    "long": "Ontario",
    "short": "ON"
},
{
    "long": "Prince Edward Island",
    "short": "PE"
},
{
    "long": "Quebec",
    "short": "QC"
},
{
    "long": "Saskatchewan",
    "short": "SK"
},
{
    "long": "Yukon",
    "short": "YT"
}
];